import { BlurImage } from "../hooks/blurImage";
import "../styles/ProjectDisplay.css";

function ProjectDisplay({ selectedProject, setSelectedProject, projectItems }) {
  const handleNextProject = () => {
    const currentIndex = projectItems.findIndex(
      (project) => project.name === selectedProject
    );
    const nextIndex = (currentIndex + 1) % projectItems.length;
    setSelectedProject(projectItems[nextIndex].name);
  };

  const handlePreviousProject = () => {
    const currentIndex = projectItems.findIndex(
      (project) => project.name === selectedProject
    );
    const previousIndex =
      (currentIndex - 1 + projectItems.length) % projectItems.length;
    setSelectedProject(projectItems[previousIndex].name);
  };

  return (
    <div className="project-tab-container">
      <div className="project-tab-content">
        <div className="title-container">
          <button className="arrow-button left" onClick={handlePreviousProject}>
            <img src="../assets/arrow-left.svg" alt="<" />
          </button>
          <div className="project-tab">
            {projectItems.map((item, index) => (
              <div
                key={index}
                className={`project-title ${
                  selectedProject === item.name ? "active" : ""
                }`}
              >
                <h3 className="project-title-text">{item.name}</h3>
              </div>
            ))}
          </div>
          <button className="arrow-button right" onClick={handleNextProject}>
            <img src="../assets/arrow-right.svg" alt=">" />
          </button>
        </div>
        {projectItems
          .filter((item) => item.name === selectedProject)
          .map((item, index) => (
            <div className="image-container" key={index}>
              <div className="image-content">
                {item.images.lowQuality.map((lowSrc, imgIndex) => {
                  const highSrc = item.images.highQuality[imgIndex];
                  return (
                    <div key={imgIndex} className="image-wrapper">
                      <BlurImage
                        lowSrc={lowSrc}
                        highSrc={highSrc}
                        alt={`Project ${item.name} ${imgIndex + 1}`}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ProjectDisplay;
